module.exports = __webpack_public_path__ + "media/application/images/euiss-white-21d9ae2f9c628b0d43fa68f8a3d3d220.svg";